import { ExpandableItemsListDrawer } from '../../molecules/ExpandableBarcodeList/ExpandableBarcodeList'
import { useAutoExpandFlow, type FlowProps } from '../../../hooks'
import { useStore } from '../../../store'
import type AppStore from '../../../store/AppStore'

export function useShoppingReceiptFlow(store: AppStore): FlowProps {
  return useAutoExpandFlow(store)
}

export default function ShoppingReceiptExpandableList() {
  const store = useStore()
  const flow = useShoppingReceiptFlow(store)
  return <ExpandableItemsListDrawer {...flow} />
}
